"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPessoaComDeficiencia = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M12.5 8c1.5 0 2.5.888 2.5.888l-1 1.332c-.5-.444-3-1.343-3 1.776 0 3.108 2.5 2.22 3 1.776l1 1.332s-1 .888-2.5.888c-1.532 0-3.5-.888-3.5-3.996S10.978 8 12.5 8zM18.509 8C19.922 8 22 8.888 22 11.996S20.03 16 18.704 16H16V8h2.509zM18 9.374v5.252c.702 0 1.069-.192 1.433-.577.364-.392.567-1.053.567-2.053 0-.685-.112-1.252-.294-1.63-.182-.377-.429-.634-.741-.773-.312-.146-.506-.22-.965-.22zM4 8c2 0 4 .068 4 2.732S6 13.396 4 13.4v2.591H2V8.068L4 8zm0 4.039c1 0 2-.043 2-1.375S5 9.418 4 9.418v2.62z' }))); };
exports.default = SvgPessoaComDeficiencia;
//# sourceMappingURL=PessoaComDeficiencia.js.map